module.exports = __webpack_public_path__ + "img/tel.9407ef42.png";